import { SaveData } from 'utils/api/types';
import apiClient from 'apiClient';
import { AdminDetailsDataMapper } from 'utils/api/admins/types';
import { DetailsDataStructure } from 'components/DetailsPageBoilerplate/types';

export const updateAdmin = (adminId: string, values: SaveData) =>
  apiClient.post(`/api/v1/broker-management/update-admin/${adminId}`, values);

export const fetchAdminDetails = (dataMapper: AdminDetailsDataMapper): Promise<DetailsDataStructure> =>
  apiClient
    .get(`/api/v1/broker-management/admin-profile`)
    .then((res) => res.data)
    .then((data) => dataMapper.map(data));
